'use strict';
export const UPDATE_MENU = 'UPDATE_MENU';
export const UPDATE_DEFAULTVALUE = 'UPDATE_DEFAULTVALUE';
